import algosdk from 'algosdk';
export default function createAsaTxn(params) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var txn = {};
  var addr = args.creator;
  var note = args.note || "";
  var totalIssuance = args.amount || 1;
  var decimals = args.decimals !== undefined ? args.decimals : 6;
  var defaultFrozen = args.defaultFrozen || false;
  var manager = args.manager || undefined;
  var clawback = args.clawback || undefined;
  var reserve = args.reserve || undefined;
  var freeze = args.freeze || undefined;
  var assetName = args.assetName || "";
  var unitName = args.unitName || args.assetName;
  var assetURL = args.assetURL || undefined;
  var assetMetadataHash = args.assetMetadataHash || undefined;
  console.log("Preparing create ASA transaction...");
  txn = algosdk.makeAssetCreateTxn(addr, 1000, parseInt(params.firstRound), parseInt(params.lastRound), note, params.genesisHash, params.genesisID, totalIssuance, decimals, defaultFrozen, manager, reserve, freeze, clawback, unitName, assetName, assetURL, assetMetadataHash, undefined);
  return txn;
}